<template>
    <section class="resource-card bg-rothcoWhite">
        <div class="resource-card__content" >
            <p class="resource-card__title title-s">{{ props.resource.name }}</p>
            <ul class="resource-card__list">
                <li class="resource-card__parent-folder">
                    <FolderIcon class="resource-card__icon" src="@icons/folder-icon.svg" alt=""/>
                    <p class="paragraph-caption">{{ props.resource.folderName }}</p>
                </li>

                <!-- IMAGE -->
                <li v-if="props.resource.type == 'image'" class="resource-card__file-type">
                    <ImageIcon class="resource-card__icon" alt=""/>
                    <p class="paragraph-caption">Image</p>
                </li>
                <!-- PDF -->
                <li v-else-if="props.resource.type == 'pdf'" class="resource-card__file-type">
                    <PdfIcon class="resource-card__icon" alt=""/>
                    <p class="paragraph-caption">PDF</p>
                </li>
                <!-- PAGE -->
                <li v-else-if="props.resource.type == 'page'" class="resource-card__file-type">
                    <WebpageIcon class="resource-card__icon" alt=""/>
                    <p class="paragraph-caption">Page</p>
                </li>

                <li class="resource-card__upload-date">
                    <DateIcon class="resource-card__icon" alt=""/>
                    <p class="paragraph-caption">{{ useDateFormat(props.resource.date_published, 'MM/DD/YYYY')?.value }}</p>
                </li>
            </ul>

            <ul class="resource-card__links">
                <li v-if="props.resource.type == 'image'"><a id="preview" class="paragraph-default" @click.prevent="preview(props.resource.name, props.resource.url)">Preview</a></li>
                <li><a @click="download($event, props.resource.url)" id="download" class="paragraph-default" :href="getLink()" :download="isRothcoResource(props.resource.url) ? getFileName() : undefined">Download</a></li>
            </ul>
            
        </div>
        <img v-if="props.resource.type == 'image' && props.resource.thumbnailImageUrl && isRothcoResource(props.resource.url)" class="resource-card__thumbnail" 
            :src="props.resource.thumbnailImageUrl" :alt="props.resource.name"/>
    </section>
</template>

<script lang="ts" setup>
    import { useDateFormat } from "@vueuse/core";
    import {useDialog} from "primevue/usedialog"
    import ImagePreviewModal from "@/components/ImagePreviewModal.vue";
    import { useSettingsStore } from "@/store/settings";
    import FolderIcon from "@icons/folder-icon.svg";
    import ImageIcon from "@icons/image-icon.svg";
    import PdfIcon from "@icons/pdf-icon.svg";
    import WebpageIcon from "@icons/webpage-icon.svg";
    import DateIcon from "@icons/date-icon.svg";
    import { useFetch } from "@/helpers/composables/useFetch";
    import { inject } from "vue";
    let { setNotificationMessage } = useSettingsStore();
    const props = defineProps({
        resource: {
            type: Object,
            default(){
                return {};
            }
        }
    })

    let route = inject('route') as any;
    
    const download = async function ($event, resourceUrl: string) {
        if(!isRothcoResource(resourceUrl)){
            $event.preventDefault();
            let s3Path = resourceUrl?.split(".com/").pop()
            useFetch(route('dealertools.viewFile', {path: s3Path}), {
                beforeFetch(ctx){
                    ctx.options.headers = {
                        ...ctx.options.headers,
                        'Accept': 'application/blob', // Ensure the response is treated as a blob
                    }
                    return ctx;
                },
                afterFetch(ctx){
                    const url = window.URL.createObjectURL(ctx.data);
                    const a = document.createElement("a");
                    a.href = url;

                    a.download = getFileName(); // Use the same filename logic
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    return ctx;
                },
                
            }).get().blob();
            
            return;
        }
        
       
    };
    const dialogRef = useDialog();


    function preview(resourceName, imageUrl: string) {
        dialogRef?.open(ImagePreviewModal,{
            props: {
                showHeader: false,
                modal: true,
            },
            data: {
                resource_name: resourceName,
                image_url: imageUrl
            }
        });
    }

    function getFileName() {
        let fileExtensionFromUrl = (props.resource.url) ? props.resource.url.split('.').pop() : "";
        if (fileExtensionFromUrl && fileExtensionFromUrl.length > 0) {
            return props.resource.name.replace(/\.[^/.]+$/, "") + "." + fileExtensionFromUrl;
        }
        return props.resource.name.replace(/\.[^/.]+$/, "") + "." + props.resource.type;
    }

    function getLink(){
        let url = props.resource.url ? props.resource.url : "#";

        let isAlpha = window.location.hostname.includes("alpha") || window.location.hostname.includes(".test");
        let isBeta = window.location.hostname.includes("beta");
        let isRothcoResource = props.resource.url ? props.resource.url.includes("www.rothco.") : false;
        if(!isRothcoResource) {
            return url;
        }
        if (isAlpha && !url.includes("alpha.rothco.")) {
            url = url.replace("www.rothco.", "alpha.rothco.");
        }else if(isBeta && !url.includes("beta.rothco.")){
            url = url.replace("www.rothco.", "beta.rothco.");
        }
        return url
    }

    function isRothcoResource(url: string) {

        let isAlpha = window.location.hostname.includes("alpha") || window.location.hostname.includes(".test");
        let isBeta = window.location.hostname.includes("beta");
        let isRothcoResource = props.resource.url ? props.resource.url.includes("www.rothco.") : false;
        return isRothcoResource || 
            (isAlpha && url.includes("alpha.rothco.")) || 
            (isBeta && url.includes("beta.rothco."));
    }
    
</script>